import AddCircularIcon from './AddCircularIcon'

export default AddCircularIcon
